import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FaArrowUp } from 'react-icons/fa';
import { theme } from '../utils/theme';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.$visible ? '1' : '0'};
  transform: ${props => props.$visible ? 'translateY(0)' : 'translateY(20px)'};
  pointer-events: ${props => props.$visible ? 'auto' : 'none'};
  transition: all 0.3s ease;
  z-index: 1000;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.3);
    transform: ${props => props.$visible ? 'translateY(-3px)' : 'translateY(20px)'};
  }

  svg {
    transition: transform 0.3s ease;
    position: relative;
    z-index: 1;
  }

  &:hover svg {
    transform: scale(1.1);
  }

  @media (min-width: 768px) {
    bottom: 32px;
    right: 32px;
    width: 48px;
    height: 48px;
  }
`;

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <ScrollButton 
      $visible={visible} 
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <FaArrowUp color="#ffffff" size={16} />
    </ScrollButton>
  );
};

export default ScrollToTop;